export {Link, type LinkSize} from './link';
